import { render, staticRenderFns } from "./next-grade.vue?vue&type=template&id=22aaebd5"
import script from "./next-grade.vue?vue&type=script&lang=js"
export * from "./next-grade.vue?vue&type=script&lang=js"
import style0 from "./next-grade.vue?vue&type=style&index=0&id=22aaebd5&prod&lang=css&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports